import { render, staticRenderFns } from "./createProfileModal.vue?vue&type=template&id=543293c4&"
import script from "./createProfileModal.vue?vue&type=script&lang=js&"
export * from "./createProfileModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports